import {
  CRACKMAP_INITIAL_ZOOM,
  CRACKMAP_WMTS_FORMAT,
  CRACKMAP_WMTS_SERVICE_URL,
  CRACKMAP_WMTS_TILE_MATRIX_SET,
} from '../crackmaps/crackmapCatalog';
import type { DefectOverviewGridConfig } from '../defectOverlays/overviewGrid';
import {
  formatPas2161LayerId,
  PAS2161_AGGREGATIONS_M,
  parsePas2161LayerId,
  withAggregation,
  type Pas2161AggregationM,
} from './pas2161LayerModel';

const OVERVIEW_ZOOM_BANDS: readonly {
  readonly minZoom: number;
  readonly maxZoom: number;
}[] = [
  { minZoom: 0, maxZoom: 13 },
  { minZoom: 13, maxZoom: 15 },
  { minZoom: 15, maxZoom: 17 },
  { minZoom: 17, maxZoom: CRACKMAP_INITIAL_ZOOM },
];

export function resolvePas2161OverviewGrid(
  sourceLayerId: string | null | undefined,
): DefectOverviewGridConfig | null {
  const parsed = parsePas2161LayerId(sourceLayerId ?? '');
  if (!parsed || parsed.aggregationM != null) {
    return null;
  }

  return {
    serviceUrl: CRACKMAP_WMTS_SERVICE_URL,
    tileMatrixSet: CRACKMAP_WMTS_TILE_MATRIX_SET,
    format: CRACKMAP_WMTS_FORMAT,
    bands: PAS2161_AGGREGATIONS_M.map((aggregationM: Pas2161AggregationM, index: number) => {
      const zoom = OVERVIEW_ZOOM_BANDS[index];
      return {
        layerId: formatPas2161LayerId(withAggregation(parsed, aggregationM)),
        style: 'point',
        minZoom: zoom.minZoom,
        maxZoom: zoom.maxZoom,
      };
    }),
  };
}
